const getFormattedChips = (initChips, fieldName) => {
  if (!initChips || !initChips.length) return;
  return initChips.map((item) => item[fieldName]);
};

export default getFormattedChips;
